import type { PartnerFeatureFlag } from '@fukuri-admins/apis/client/gen/model';

/**
 * PartnerFeatureFlag 一覧から指定したフラグが有効かを判定する純粋関数。
 *
 * `feature_key` が一致し `enabled` なフラグが存在すれば `true` を返す。
 * かつてはテナントコードのハードコード（BYM/LEF/SHL）で制御していたが、
 * 対象テナントを FeatureFlag で管理できるようにするため本関数へ移行した（MMT-156）。
 *
 * @param flags PartnerFeatureFlag の配列
 * @param featureKey 判定対象のフラグキー（例: `activation_code`）
 * @returns 指定フラグが有効なら `true`
 */
export const isPartnerFeatureFlagEnabled = (
  flags: PartnerFeatureFlag[],
  featureKey: string
): boolean => flags.some(flag => flag.feature_key === featureKey && flag.enabled);
